<template>
    <div class="fw-wfp">
        <van-nav-bar :title="title" style="background-color: #CCD5E6;" left-text="" @click-left="onClickLeft" left-arrow
                     :fixed="true">
        </van-nav-bar>
        <div style="">
            <van-tabs v-model="active">
                <van-tab :title="'排号('+tasks.length+')'">
                    <div class="ph-items">
                        <div class="ph-item" v-for="item in tasks">
                            <div class="ph-xh">
                                <span>排队序号</span>
                                <span style="font-size: 20px;color: red" v-if="item.taskNo">A{{item.taskNo}}</span>
                            </div>
                            <span class="ph-nr">排号时间: {{item.createTime}}</span>
                            <span class="ph-nr">客户昵称: {{item.memberName}}</span>
                            <span class="ph-nr">手机号码: {{item.phone}}</span>
                            <span class="ph-nr">顾客人数: {{item.memberNum}}</span>
                            <span class="ph-nr">技师级别: {{item.gradeName}}</span>
                            <span class="ph-nr" style="white-space: nowrap;text-overflow: ellipsis;overflow: hidden;">服务项目: {{item.fwText}}</span>
                            <span class="ph-nr">人员分配: {{item.empName}}</span>
                            <span class="ph-nr" style="display:flex;flex-direction: row;justify-content: space-between">服务号码: {{item.roomName}}
                                <span style="color: #2b94ff;cursor: pointer" @click="getFwRooms(item)">更改服务号</span>
                            </span>
                            <div class="ph-btns">
                                <div class="ph-btn" @click="toDel(item)"><i
                                        class="el-icon-delete ph-icon"/><span>过号取消</span>
                                </div>
                                <div class="ph-btn"><i class="el-icon-bell ph-icon"/><span>呼叫</span></div>
                                <div class="ph-btn" @click="toLq(item)" v-if="userType==3&&item.btn"><i
                                        class="el-icon-edit-outline ph-icon"/><span>领取并开单</span>
                                </div>
                                <div class="ph-btn" v-if="userType==2||!item.btn"><i
                                        class="el-icon-edit-outline ph-icon"/><span>不能领取</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </van-tab>
                <van-tab title="预约未分配(0)">
                    <span style="display: block;text-align: center;padding: 30px 0px;font-size: 15px">暂无数据</span>
                </van-tab>
                <van-tab title="推项(0)">
                    <span style="display: block;text-align: center;padding: 30px 0px;font-size: 15px">暂无数据</span>
                </van-tab>
            </van-tabs>
        </div>

        <van-popup ref="vanpopup" v-model="fjShow" position="bottom" closeable lock-scroll overlay
                   :close-on-click-overlay="false"
                   style="height: 100%;">
                <span class="xmbt">
                    选择方式
                </span>
            <div class="fw-fjs">
                <div class="fw-fjs-item" v-for="item in rooms" @click="updateServiceNo(item)">
                    <span class="fjm">{{item.roomName}}</span>
                    <span class="fj-btn">点击开单</span>
                </div>
            </div>
        </van-popup>
    </div>
</template>

<script>
    import {getCookie} from "../../utils/auth";

    export default {
        components: {},
        data() {
            return {
                title: '未分配领取',
                deptId: '',
                token: '',
                fwUser: {},
                active: 0,

                taskId: '',
                tasks: [],

                rooms: [],
                fjShow: false,
            };
        },
        async created() {
            document.title = "数字智慧助手"
            this.fwUser = JSON.parse(getCookie("fwUser"))
            this.token = this.fwUser.token
            this.userType = this.fwUser.userType
            this.deptId = this.fwUser.deptId
            this.getBillingTasks()
        },
        methods: {
            async getBillingTasks() {
                let data = {
                    deptId: this.deptId,
                    token: this.token
                }
                let res = await this.$get("/fw/getFwBillingTasks", data)
                this.tasks = res.list
            },

            toDel(item) {
                this.$dialog.confirm({
                    title: '提示',
                    message: '是否取消?'
                }).then(() => {
                    this.delBillingTask(item.id)
                }).catch(() => {
                    // on cancel
                });
            },

            async delBillingTask(id) {
                let data = {
                    id: id
                }
                let res = await this.$post("/fw/fwDelBillingTask", data)
                if (res.code == 200) {
                    this.getBillingTasks()
                    this.$notify({type: 'success', message: res.message});
                } else {
                    this.$notify({type: 'danger', message: res.message});
                }
            },
            async getFwRooms(item) {
                this.taskId = item.id
                this.fjShow = true
                let data = {
                    deptId: this.deptId
                }
                let res = await this.$get("/fw/getFwRooms", data)
                this.rooms = res.list
            },

            async updateServiceNo(item) {
                let data = {
                    id: this.taskId,
                    serviceNo: item.roomNo,
                }
                let res = await this.$post("/fw/updateBillingTask", data)
                if (res.code == 200) {
                    this.tasks.forEach(it => {
                        if (it.id == this.taskId) {
                            it.roomName = item.roomName
                        }
                    })
                    this.fjShow = false
                    this.$notify({type: 'success', message: res.message});
                } else {
                    this.$notify({type: 'danger', message: res.message});
                }
            },

            onClickLeft() {
                this.$router.go(-1)
            },
            toLq(item) {
                if (!item.id) {
                    this.$notify({type: 'danger', message: '领取错误'});
                    return;
                }
                this.$router.push('/empLqBilling?taskId=' + item.id)
            },
        },
    };
</script>

<style lang="scss" scoped>

    .fw-wfp {
        margin: 0 auto;
        height: 100%;
        position: relative;
        overflow: scroll;
        padding-top: 46px;
        background-color: #EEEEEE;
    }

    .ph-items {
        display: flex;
        flex-direction: column;
        padding: 0px 8px;
    }

    .ph-item {
        display: flex;
        flex-direction: column;
        padding: 18px;
        background-color: #ffffff;
        margin-top: 8px;
    }

    .ph-xh {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        font-size: 13px;
        border-bottom: #EEEEEE solid 1px;
        padding-bottom: 3px;
        margin-bottom: 8px;
    }

    .ph-nr {
        height: 32px;
        line-height: 32px;
        font-size: 13px;
    }

    .ph-btns {
        font-size: 14px;
        font-weight: bold;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        padding: 5px 16px;
        margin-top: 13px;
    }

    .ph-btn {
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
    }

    .ph-icon {
        font-size: 18px;
        margin-right: 3px;
    }

    .xmbt {
        display: block;
        text-align: center;
        font-size: 15px;
        padding: 16px 10px;
        background-color: #CCD5E6;
    }

    .fw-fjs {
        display: flex;
        flex-flow: row wrap;
        padding: 0px 8px;
    }

    .fw-fjs-item {
        /*flex: 1;*/
        box-sizing: border-box;
        padding: 8px;
        margin-bottom: 8px;
        display: flex;
        flex-direction: column;
        cursor: pointer;
        width: calc(100% / 3); // 我这里一行显示4个 所以是/4  一行显示几个就除以几
        min-width: calc(100% / 3);
        max-width: calc(100% / 3);

        &:nth-child(3n + 3) {
            margin-right: 0;
        }
    }

    .fjm {
        font-size: 15px;
        height: 60px;
        text-align: center;
        line-height: 60px;
        border-top: silver solid 1px;
        border-left: silver solid 1px;
        border-right: silver solid 1px;
    }

    .fj-btn {
        font-size: 13px;
        text-align: center;
        padding: 5px;
        border: silver solid 1px;
        background-color: #dddddd;
    }


</style>
